export const deleteMedia = `mutation ($date: timestamptz, $id: Int!) {
    item: update_prodigio_medias_by_pk(pk_columns: {id: $id}, _set: {deleted: $date}) {
      id
    }
  }
  `;
